import React from 'react';
import './NotasEntradaItem.css';

const NotasEntradaItem = ({ nota, isSelected, onSelect }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatCurrency = (value) => {
    if (!value) return '-';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  return (
    <div
      className={`nota-entrada-item ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(nota)}
    >
      <div className="nota-header">
        <span className="nota-id">#{nota.notaNumero}</span>
        <span className="nota-tenant">Empresa {nota.tenantId}</span>
      </div>
      <div className="nota-fornecedor">{nota.nomeCliente || '-'}</div>
      <div className="nota-meta">
        <span className="nota-data">{formatDate(nota.dataPedido)}</span>
        <span className="nota-valor">{formatCurrency(nota.valorTotalNota)}</span>
      </div>
      {nota.statusPedido && (
        <div className="nota-status">{nota.statusPedido}</div>
      )}
    </div>
  );
};

export default NotasEntradaItem;
